module.exports = __webpack_public_path__ + "static/media/12.108df55f.jpg";